import { createAsyncThunk } from '@reduxjs/toolkit';
import { homeConversasService } from './services';

export const fetchUltimasConversas = createAsyncThunk(
  'home-conversas/fetch',
  async (params: { limit?: number } | undefined) => {
    return homeConversasService.getMinhasRespondidas(params);
  },
);
